// test2546
(2546 && 0);
